// extracted by mini-css-extract-plugin
export default {"formHeading":"eJ-z","form":"fJ-z","submitBtn":"gJ-z","disabled":"hJ-z","input":"iJ-z","error":"jJ-z","submitMsg":"kJ-z","signIn":"lJ-z"};